const handleGetAllChats = async (user_id, bot_id, start, end, page) => {
  const serverDomain = process.env.REACT_APP_SERVER;
  const url = `${serverDomain}/other/conversions?user_id=${user_id}&bot_id=${bot_id}&start=${start}&end=${end}&page=${page}`;

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      // Throw an error if the response status is not OK (2xx)
      console.error(`Network response was not ok: ${res.statusText}`);
      return {
        data: [],
        error: true,
        pagination: null,
      };
    }

    const data = await res.json();

    return {
      data: data?.data || [],
      error: false,
      pagination: data?.pagination || {},
    };
  } catch (error) {
    console.error("Error fetching chats:", error);
    return {
      data: [],
      error: true,
      pagination: null,
    };
  }
};

export default handleGetAllChats;
